/**
 * `manutention_ascenseur` est une chaîne, « oui » ou « non » (validée ainsi par
 * l'API) : la tester en booléen affichait « Oui » pour « non », chaîne non vide.
 */
export const libelleAscenseur = (valeur) => {
  if (valeur === "oui") return "Oui";
  if (valeur === "non") return "Non";
  return "—";
};
